import NumberInput from './NumberInput';

// export types
export type { NumberInputProps } from './NumberInput';

// export components
export { NumberInput };
export default NumberInput;
